export type Language = 'en' | 'bg';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'bg', label: 'Български', flag: '🇧🇬' },
];

const translations = {
  en: {
    // Header
    bnbOfficial: 'BNB Official Fixing',
    // AnchorNav
    navConverter: 'Currency Converter',
    // PageHero
    heroBadge: 'Official BNB Fixing — 01.01.2025',
    heroTitle: '',
    heroTitleHighlight: 'Exchange Calculator',
    heroDesc: 'Convert between EUR, USD, and BGN using the official rates published by the',
    heroBNB: 'Bulgarian National Bank (BNB)',
    heroRatesFixed: 'Rates fixed as of 01.01.2025.',
    // RatesInfoCard
    officialRates: 'Official BNB Exchange Rates',
    effectiveDate: 'Effective date: 01 January 2025',
    ratesFixed: 'Rates are fixed — not live market rates',
    fixedEUParity: 'Fixed EU parity',
    bnbMarketFixing: 'BNB market fixing',
    // UnifiedConverter
    officialBNBFixing: 'Official BNB Fixing, 01.01.2025',
    from: 'From',
    to: 'To',
    swapCurrencies: 'Swap currencies',
    amount: 'Amount',
    result: 'Result',
    copyResult: 'Copy result to clipboard',
    copiedToClipboard: 'Copied to clipboard!',
    atOfficialRate: 'at the official BNB rate',
    quickReference: 'Quick Reference',
    commonAmounts: 'Common amounts at official BNB rates',
    // SiteFooter
    footerRates: 'Exchange rates based on the',
    footerBNB: 'Bulgarian National Bank (BNB)',
    footerFixing: 'official fixing as of',
    footerCopyright: '© 2025 BNBCalc — For informational purposes only.',
    footerAuthor: 'Author',
    footerSchool: 'School',
    footerTheme: 'Theme/Subject',
    footerAuthorName: 'Daniel Krasimirov Duganov',
    footerSchoolName: 'St. St. Cyril and Methodius High School',
    footerThemeName: '"Organization and Techniques of International Payments"',
    // Currency names
    currencyEUR: 'Euro',
    currencyUSD: 'US Dollar',
    currencyBGN: 'Bulgarian Lev',
  },
  bg: {
    // Header
    bnbOfficial: 'Официален Фиксинг на БНБ',
    // AnchorNav
    navConverter: 'Валутен Калкулатор',
    // PageHero
    heroBadge: 'Официален Фиксинг на БНБ — 01.01.2025',
    heroTitle: '',
    heroTitleHighlight: 'Валутен Калкулатор',
    heroDesc: 'Конвертирайте между EUR, USD и BGN по официалните курсове, публикувани от',
    heroBNB: 'Българска Народна Банка (БНБ)',
    heroRatesFixed: 'Курсовете са фиксирани към 01.01.2025.',
    // RatesInfoCard
    officialRates: 'Официални Валутни Курсове на БНБ',
    effectiveDate: 'Дата на влизане в сила: 01 януари 2025',
    ratesFixed: 'Курсовете са фиксирани — не са пазарни в реално време',
    fixedEUParity: 'Фиксиран паритет с ЕС',
    bnbMarketFixing: 'Пазарен фиксинг на БНБ',
    // UnifiedConverter
    officialBNBFixing: 'Официален Фиксинг на БНБ, 01.01.2025',
    from: 'От',
    to: 'Към',
    swapCurrencies: 'Размени валутите',
    amount: 'Сума',
    result: 'Резултат',
    copyResult: 'Копирай резултата',
    copiedToClipboard: 'Копирано!',
    atOfficialRate: 'по официалния курс на БНБ',
    quickReference: 'Бърза Справка',
    commonAmounts: 'Чести суми по официалните курсове на БНБ',
    // SiteFooter
    footerRates: 'Валутните курсове са базирани на',
    footerBNB: 'Българска Народна Банка (БНБ)',
    footerFixing: 'официален фиксинг към',
    footerCopyright: '© 2025 BNBCalc — Само за информационни цели.',
    footerAuthor: 'Автор',
    footerSchool: 'Училище',
    footerTheme: 'Тема/Предмет',
    footerAuthorName: 'Даниел Красимиров Дуганов',
    footerSchoolName: 'ППМГ „Св. св. Кирил и Методий"',
    footerThemeName: '„Организация и техники на международните плащания"',
    // Currency names
    currencyEUR: 'Евро',
    currencyUSD: 'Щатски Долар',
    currencyBGN: 'Български Лев',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function getTranslations(language: Language) {
  return translations[language];
}
